import { render, staticRenderFns } from "./chukuzuoye.vue?vue&type=template&id=32c99c36&scoped=true&"
import script from "./chukuzuoye.vue?vue&type=script&lang=js&"
export * from "./chukuzuoye.vue?vue&type=script&lang=js&"
import style0 from "./chukuzuoye.vue?vue&type=style&index=0&id=32c99c36&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c99c36",
  null
  
)

export default component.exports